import React from 'react'
import Banner from './Banner'
import Footer from "../components/footer"
import Header from "../components/header"
import EmailSignup from './EmailSignup'
import EmailModal from '../components/EmailModal'
import AdComponent from "../components/AdComponent"
import {graphql, useStaticQuery} from 'gatsby'

const Layout = ({isIndex, children}) => {
    const data = useStaticQuery(graphql`
        query LayoutAdQuery {
            allWpAd(
                filter: {adPositions: {nodes: {elemMatch: {slug: {in: ["above-email-signup"]}}}}}
            ) {
                nodes {
                    id
                    title
                    adPositions {
                        nodes {
                            slug
                        }
                    }
                    adFields {
                        altText
                        endDate
                        externalLink
                        startDate
                    }
                    featuredImage {
                        node {
                            mediaItemUrl
                        }
                    }
                }
            }
        }
    `)

    const filterAdsByPosition = (ads, position) => {
        return ads.nodes.filter(ad => {
            return ad.adPositions.nodes.some(node => node.slug === position)
        })
    }

    return (
        <div>
            { isIndex &&
            <Banner
                text="First time here? Learn how to use the site to study and understand the Bible more."
                cta="Start Here"
                link="/how-to-use-this-site"
            />
            }
            <Header />
            {children}
            <AdComponent ads={filterAdsByPosition(data.allWpAd, "above-email-signup")} position="above-email-signup" />
            <EmailSignup/>
            <EmailModal />
            <Footer />
        </div>
    )
}

export default Layout
